import styled from "styled-components/macro";

import { wrapLongWords } from "UI/styles";

export const SignupItemWrapper = styled.div`
  background: white;
  border: 1px solid #eae9e9;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.05);
  padding: 24px 28px;
  color: #222;
  margin-bottom: 20px;
  opacity: ${({ dim }) => (dim ? "0.5" : "1")};
  transition: opacity 200ms;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 21px;
  font-weight: 400;
  ${wrapLongWords}

  @media (max-width: 500px) {
    font-size: 18px;
  }
`;

export const TitleButtonWrapper = styled.div`
  margin-left: 8px;
  white-space: nowrap;
`;
